module.exports = __webpack_public_path__ + "img/pollution_level_5.e534ac4e.png";